import { Provider } from 'react-redux';
import './App.css';
import MainRoutes from './Routes/MainRoutes';
import { UserProvider } from './contexts/UserContext';
import { SiteSettingsProvider } from './contexts/SiteSettingsContext';
import { store } from './stores/Store';
import ErrorBoundary from './Components/ErrorBoundary';
import BrandingInit from './brandingInit';

function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <SiteSettingsProvider>
          <UserProvider>
            <BrandingInit />
            <MainRoutes />
          </UserProvider>
        </SiteSettingsProvider>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
